import { render } from "./InstituteView.vue?vue&type=template&id=266e5804&scoped=true"
import script from "./InstituteView.vue?vue&type=script&lang=js"
export * from "./InstituteView.vue?vue&type=script&lang=js"

import "./InstituteView.vue?vue&type=style&index=0&id=266e5804&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-266e5804"]])

export default __exports__